import { defineMessages } from 'react-intl';

const scope = `app.components.taptotip.setup.branding_section`;

export default defineMessages({
  title: { id: `${scope}.title`, defaultMessage: 'Branding' },
  description: {
    id: `${scope}.description`,
    defaultMessage:
      'Brand your review & tipping pages. Most guests view these on a phone, so keep text short and images light.'
  },
  save: { id: `${scope}.save`, defaultMessage: 'Save Branding' },
  companyName: { id: `${scope}.company_name`, defaultMessage: 'Company name' },
  headline: { id: `${scope}.headline`, defaultMessage: 'Headline' },
  subtext: { id: `${scope}.subtext`, defaultMessage: 'Subtext' },
  colours: { id: `${scope}.colours`, defaultMessage: 'Colours' },
  primary: { id: `${scope}.primary`, defaultMessage: 'Primary' },
  secondary: { id: `${scope}.secondary`, defaultMessage: 'Secondary' },
  background: { id: `${scope}.background`, defaultMessage: 'Background' },
  text: { id: `${scope}.text`, defaultMessage: 'Text' },
  heading: { id: `${scope}.heading`, defaultMessage: 'Heading' },
  images: { id: `${scope}.images`, defaultMessage: 'Images' },
  headerImage: { id: `${scope}.header_image`, defaultMessage: 'Header image' },
  headerImageHint: {
    id: `${scope}.header_image_hint`,
    defaultMessage: 'Best at 1600 × 500px — other sizes are cropped to fit.'
  },
  logoImage: { id: `${scope}.logo_image`, defaultMessage: 'Logo (circle)' },
  logoImageHint: {
    id: `${scope}.logo_image_hint`,
    defaultMessage: 'Best as a square image (e.g. 400 × 400px) so it fits the circle.'
  },
  footerImage: { id: `${scope}.footer_image`, defaultMessage: 'Footer image' },
  footerImageHint: {
    id: `${scope}.footer_image_hint`,
    defaultMessage: 'Best at 1600 × 400px — other sizes are cropped to fit.'
  },
  whiteLogoBackground: {
    id: `${scope}.white_logo_background`,
    defaultMessage: 'White background behind logo'
  },
  whiteLogoBackgroundHelp: {
    id: `${scope}.white_logo_background_help`,
    defaultMessage: 'Draw a white card behind your logo. Off by default — the logo sits directly on the page.'
  },
  generateWithAi: {
    id: `${scope}.generate_with_ai`,
    defaultMessage: 'Generate with AI'
  },
  generating: {
    id: `${scope}.generating`,
    defaultMessage: 'Generating…'
  },
  uploading: {
    id: `${scope}.uploading`,
    defaultMessage: 'Uploading…'
  },
  generateError: {
    id: `${scope}.generate_error`,
    defaultMessage: "Couldn't generate an image. Please try again."
  },
  uploadError: {
    id: `${scope}.upload_error`,
    defaultMessage: "Couldn't upload the image. Please try again."
  },
  removeImage: {
    id: `${scope}.remove_image`,
    defaultMessage: 'Remove image'
  },
  generateFromSiteTitle: {
    id: `${scope}.generate_from_site_title`,
    defaultMessage: 'Generate from my site'
  },
  generateFromSiteHelp: {
    id: `${scope}.generate_from_site_help`,
    defaultMessage:
      "Enter your website and we'll scan it for your colours, fonts, logo and a headline. Review the result in the preview, then save."
  },
  generateFromSite: {
    id: `${scope}.generate_from_site`,
    defaultMessage: 'Scan my site'
  },
  scanningSite: {
    id: `${scope}.scanning_site`,
    defaultMessage: 'Scanning your site…'
  },
  experimental: {
    id: `${scope}.experimental`,
    defaultMessage: 'Experimental'
  },
  generateFromSiteError: {
    id: `${scope}.generate_from_site_error`,
    defaultMessage: "Couldn't read branding from that site. Please try again."
  }
});
